import CRUD from './crud'

export default new CRUD('tournament-judges', 'superior-judge')
